import gql from "graphql-tag";
const DISABLE_TWOFA = gql`
  mutation disable2fa($enable2faInput: Enable2faDto!) {
    disable2fa(enable2faInput: $enable2faInput) {
        success,
        message,
        err
    }
  }
`;

export default DISABLE_TWOFA;
